import { render, staticRenderFns } from "./AssistantList.vue?vue&type=template&id=2f255cff&"
import script from "./AssistantList.vue?vue&type=script&lang=js&"
export * from "./AssistantList.vue?vue&type=script&lang=js&"
import style0 from "./AssistantList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports